import { Component, OnInit, ViewChild } from '@angular/core';
import { ExpenseReport } from 'app/core/model/expense-report';
import { DxDataGridComponent } from 'devextreme-angular';
import { Router } from '@angular/router';
import { confirm } from 'devextreme/ui/dialog';
import { AppInformationService, AuthService, GenesisUnitOfWork } from 'app/core/core.module';

@Component({
    selector: 'app-expense-reports',
    templateUrl: './expense-report-overview.component.html',
    styleUrls: ['./expense-report-overview.component.scss'],
    standalone: false,
})
export class ExpenseReportOverviewComponent implements OnInit {
    expenseReports: ExpenseReport[] = [];
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    isCreditAdmin: boolean;

    constructor(private uow: GenesisUnitOfWork, public auth: AuthService, private appInfo: AppInformationService, private router: Router) {}

    async ngOnInit() {
        this.isCreditAdmin = this.auth.hasRole('CreditCard:Admin');
        this.isCreditAdmin = true; //Until we have roles in
        this.getData();
        this.expenseReports.forEach((x) => {
            x._totalAmount = x.calcTotalAmount();
        });
    }

    async getData() {
        // Filter if not admin?
        this.expenseReports = (await this.uow.getExpenseReports()) as ExpenseReport[];
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async onRowPrepared(e) {
        if (e.rowType === 'data') {
            if (e.data.paid) {
                e.rowElement.className = e.rowElement.className + ' paid';
            } else if (e.data.approved) {
                e.rowElement.className = e.rowElement.className + ' approved';
            } else if (e.data.submitted) {
                e.rowElement.className = e.rowElement.className + ' submitted';
            }
        }
    }

    onRowDoubleClick(e) {
        this.open(e.data.id);
    }

    async open(expenseId: number) {
        this.router.navigate(['/sales-reporting/expenses/overview/' + (!!expenseId ? expenseId : 'new')]);
    }

    async deleteExpense(expenseReport: ExpenseReport) {
        const result = await confirm(`Are you sure you want to DELETE this entry?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        expenseReport.deleted = new Date();
        expenseReport.deletedBy = this.auth.currentUser.userName;

        await this.uow.commit();
        await this.getData();
    }

    async markAsApproved(expenseReport: ExpenseReport) {
        const result = await confirm(`Are you sure you want to mark this entry as approved?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        expenseReport.approved = new Date();

        await this.uow.commit();
        await this.getData();
    }

    async markAsPaid(expenseReport: ExpenseReport) {
        const result = await confirm(`Are you sure you want to mark this entry as paid?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        expenseReport.paid = new Date();

        await this.uow.commit();
        await this.getData();
    }

    async markAsSubmitted(expenseReport: ExpenseReport) {
        const result = await confirm(`Are you sure you want to Submit this Expense Report?`, `${this.appInfo.settings.company}`);
        if (!result) return;

        expenseReport.submitted = new Date();

        await this.uow.commit();
        await this.getData();
    }
}
